import { defineComponent as _defineComponent } from 'vue'
import AppButton from "@/components/common/AppButton.vue";
import { ref, type Ref, watch } from "vue";
import type { IVideographer } from "@/types/entities/IVideographer";
import routesName from "@/utils/constants/routesName";
import { useRoute } from "vue-router";

interface IProps {
  disabled?: boolean;
  data?: IVideographer[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'VideographersMenuButton',
  props: {
    disabled: { type: Boolean, default: false },
    data: { default: undefined }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { disabled: boolean, data: IVideographer[] }



const showDropdown: Ref<boolean> = ref(false);
const clickHandler = (): void => {
  if (!props.disabled) {
    showDropdown.value = !showDropdown.value;
  }
};
const clickOutside = (): void => {
  showDropdown.value = false;
};

const route = useRoute();
watch(
  () => route.params.id,
  (newV, oldV) => {
    if (newV !== oldV) {
      clickOutside();
    }
  }
);

const __returned__ = { props, showDropdown, clickHandler, clickOutside, route, AppButton, ref, watch, routesName, useRoute }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})